import { createAction } from '@reduxjs/toolkit';


export const startObserving = createAction(
    'eventObservers/startObserving'
);

export const stopObserving = createAction(
    'eventObservers/stopObserving'
);

export const removeObservedEvents = createAction(
    'eventObservers/removeObservedEvents'
);
